module.exports = __webpack_public_path__ + "img/edit_quote.bc9a2639.svg";